<template>
  <div>
    <filter-data
      :loading_block="loading"
      :months_before="1"
      :months_after="1"
      with_client_portfolios
      with_payment_option
      with_text_search
      with-vrt-situation-select
      :vrt-situation-items="payment_type"
      :vrt-situation-value="local_filter.by_status_ids"
      @doneFilter="handleDoneFilter"
    />
    <order-transactions-table
      :items="allVrts"
      :loading="loading"
      :table-search="tableSearch"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FilterData from '@/components/shared/FilterData.vue'
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'ToReceivePayments',
  mixins: [ status ],
  inject: {
    registerToReceiveListReload: {
      default: () => () => {},
    },
  },
  components: {
    OrderTransactionsTable: () => import('./shared/OrderTransactionsTable'),
    FilterData,
  },
  data() {
    return {
      
      loading: false,
      comment: '',
      comment_dialog: false,
      local_filter: {
        by_status_ids: ['overdues', 'not_payed']
      },
      payment_type:[
        {text:"EM ABERTO (VENCIDOS)", value: 'overdues', kind: 'overdue'},
        {text:"EM ABERTO (NÃO VENCIDOS)", value: 'not_payed', kind: 'available'},
        {text:"PAGOS", value: 'done', kind: 'done'},
        {text:"PROTESTADOS", value: 'protested', kind: 'protested'},
      ],
    }
  },

  computed: {
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
    ...mapState({
      allVrts: state => state.VrtTransaction.allVrtTransactions,
    }),
  },

  methods: {
    handleDoneFilter(e) {
      const { by_status_ids, ...rest } = e
      this.local_filter = {
        ...rest,
        by_status_ids:
          by_status_ids !== undefined
            ? [...by_status_ids]
            : [...(this.local_filter.by_status_ids || [])],
      }
      this.getVrt()
    },
    seeComment(comment) {
      this.comment = comment
      this.comment_dialog = true
    },
    getVrt(){
      if (this.activeModalityId){
        this.loading = true
        let filters = {
          by_place_ids: [this.activeModalityId],
          by_transaction_type_ids: [6,7,8,9], 
          ...this.local_filter,
        }
        // Mantém exportação alinhada aos mesmos params da listagem exibida
        this.$emit('localFilter', { ...filters })

        this.indexVrtTransactions(filters).finally(()=>{
          this.loading = false
        })
      } 
    },
    ...mapActions({
      indexVrtTransactions: 'VrtTransaction/index',
    })
  },
  watch: {
    activeModalityId() {
      this.getVrt()
    },
  },
  mounted() {
    this.registerToReceiveListReload(this.getVrt)
  },
  beforeDestroy() {
    this.registerToReceiveListReload(null)
  },
}
</script>
